import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable,Subscription } from 'rxjs';
import { Events} from 'ionic-angular';
import { first } from 'rxjs/operators';
import { User } from  '../../models/user';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {
  
  
  private userDoc: AngularFirestoreDocument<User>;
  user$: Observable<User>;
  public user:User;
  public uid : string;
  roles:Array<string>;
  public showSpiderGraphs:boolean = false;
  
  //Subscriptions
  userSubs:Subscription;

  constructor(private afs: AngularFirestore,private storage: Storage, public events:Events) {

  }
  async intializeSubscriptions(){

          console.log("intialising data subscriptions")

        
          this.uid = await this.storage.get('uid');
          this.roles = await this.storage.get('roles');

          if(this.uid && this.roles){

            this.userDoc = this.afs.doc<User>('users/'+ this.uid);
            this.user$ = this.userDoc.valueChanges();
            this.userSubs = this.user$.subscribe( (user:User) => {
               
                this.user = user;
                this.user.uid = this.uid;
            });
            
            await this.afs.collection('users').doc(this.uid).update({lastAccessTime : new Date()});

            let settings:any =  await this.afs.collection('config').doc('settings').valueChanges().pipe(first()).toPromise();
            if(settings && settings.showSpiderGraphs){
              this.showSpiderGraphs = true;
            }
         }
        
  }

  docExists(path: string) {
   return this.afs.doc(path).valueChanges().pipe(first()).toPromise()
  }

  getDoc(path:string){
  	return this.afs.doc(path).valueChanges().pipe(first()).toPromise()
  }

  async getDealerGroup(){
    const dealerGroup = await this.afs.collection('dealergroups', ref => ref.where('active', '==', true)).snapshotChanges().pipe(
                 map(actions => actions.map(a => {
                   const data = a.payload.doc.data() as any;
                   const id = a.payload.doc.id;
                   if(data.creationDate){
                     data.creationDate = data.creationDate.toDate();
                   }
                   return { id, ...data };
   }))).pipe(first()).toPromise();
    console.log(dealerGroup);

    return dealerGroup;
 }

  updateUserDoc(user){
      return this.userDoc.update(user);
  }

  async addPushToken(userId, token){
  	 const user:any = await this.getDoc('users/'+ userId);
  	 if(user){
       
  	 	if(user.deviceTokens && !(user.deviceTokens.includes(token))){
  	 		user.deviceTokens.push(token);
  	 	}
      else if(!user.deviceTokens){
         user.deviceTokens = [];
         user.deviceTokens.push(token);
      }
       return this.afs.collection('users').doc(userId).update({deviceTokens:user.deviceTokens});
  	 }  	

  }

  async deletePushTokens(){
    await this.afs.collection('users').doc(this.uid).update({deviceTokens:[]});
    return;
  }


  removeSubscriptions(){
      console.log("removing data subscriptions")
      if(this.userSubs){
        this.userSubs.unsubscribe();
      }
  }

  getAudits(){
    var audits = [];
    return audits;
  }


  
  async getSectionsList(typeId:string){
    const auditTypeSections = await this.afs.collection('audtypes').doc(typeId).collection('sections',ref => ref.orderBy('order').where('active', '==', true)).snapshotChanges().pipe(
                 map(actions => actions.map(a => {
                   const data = a.payload.doc.data() as any;
                   const id = a.payload.doc.id;
                   return { id, ...data };
   }))).pipe(first()).toPromise();

  //  this.events.publish('audit:sectionsList',auditTypeSections);
   console.log('auditTypeSections', auditTypeSections)
   return auditTypeSections
 }

 async getSectionQuestions(typeId:string,sectionId:string){
  const auditSectionQuestions = await this.afs.collection('audtypes').doc(typeId).collection('sections').doc(sectionId).collection('questions',ref => ref.orderBy('order').where('active', '==', true)).snapshotChanges().pipe(
               map(actions => actions.map(a => {
                 const data = a.payload.doc.data() as any;
                 const id = a.payload.doc.id;
                 return { id, ...data };
 }))).pipe(first()).toPromise();

//  this.events.publish('audit:sectionQuestions',auditSectionQuestions,sectionId);
console.log('auditSectionQuestions', auditSectionQuestions)
 return auditSectionQuestions
}

async getUserData() {
  this.uid = await this.storage.get('uid');

  if (this.uid) {
    try {
      const userDoc = await this.afs.collection('users').doc(this.uid).ref.get();
      if (userDoc.exists) {
        const userData = userDoc.data();
        console.log('User Data:', userData);
        return userData;
      } else {
        console.log('User document does not exist');
        return null;
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
    }
  } else {
    console.log('UID not found in storage');
    return null;
  }
}





}




// WEBPACK FOOTER //
// ./src/providers/data/data.ts